import {AoflElement, customElement} from '@aofl/element';
import {findParent} from '@aofl/component-utils';
import styles from './list-option.css';

/**
 * Similar to option tag can be combined with <aofl-select-list> or <aofl-multi-select-list>
 *
 * @memberof module:@aofl/select
 * @extends {AoflElement}
 */
@customElement('aofl-list-option')
class AoflListOption extends AoflElement {
  /**
   * Creates an instance of AoflListOption.
   */
  constructor() {
    super();
  }
  static is = 'aofl-list-option';
  /**
   *
   * @readonly
   * @type {Object}
   */
  static get properties() {
    return {
      selected: {type: Boolean, reflect: true},
      disabled: {type: Boolean},
      value: {type: String}
    };
  }
  /**
   * @param {Event} e
   */
  keydownCallback(e) {
    if (e.keyCode === 13 || e.keyCode === 32) { // If user hits enter or space
      this.select();
    } else if (e.keyCode === 37 || e.keyCode === 39) // If user hits left or right arrow
    {
      const index = this.listElement.options.indexOf(this);
      let nextIndex = index + 1;
      if (e.keyCode === 37) {
        nextIndex = index - 1;
      }
      if (nextIndex < 0) {
        nextIndex = 0;
      } else if (nextIndex >= this.listElement.options.length) {
        nextIndex = nextIndex = this.listElement.options.length - 1;
      }
      this.listElement.options[nextIndex].focus();
    }
  }

  /**
   * Update selected value in the parent list
   */
  select(e) {
    this.listElement.updateSelected(this, true);
  }
  /**
   *
   */
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.select);
    this.addEventListener('keydown', this.keydownCallback);

    this.updateComplete.then(() => {
      this.value = this.value || this.textContent;
      this.listElement = findParent(this, 'addOption');
      this.listElement.addOption(this);
    });
  }
  /**
   * @return {Object}
   */
  render() {
    return super.render((ctx, html) => html`<slot></slot>`, [styles]);
  }
  /**
   *
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.select);
    this.removeEventListener('keydown', this.keydownCallback);
  }
}

export default AoflListOption;
